<template>
  <section class="section information" v-if="description_text">
    <p class="information__desc">
      <vb-icon
        :name="'quote'"
        :size="35"
        :color="sass('secondary')"
        class="information__icon"
      />
      <span v-html="description_text"></span>
      <vb-icon
        :name="'quote'"
        :size="35"
        :color="sass('secondary')"
        class="information__icon"
      />
    </p>
  </section>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'description',

  props: {
    statics_detail: { type: Object, default: null }, // flight-and-stay
    hotel_data: { type: Object, default: null }, // only-stay
  },

  computed: {
    description_text() {
      // only-stay: descrizione diretta da hotel_data
      if (this.hotel_data && this.hotel_data.data) {
        return this.hotel_data.data.description || ''
      }

      // flight-and-stay: da statics_detail
      if (this.statics_detail) {
        const first = Object.values(this.statics_detail)[0]
        if (first && first.schedaProdotto) {
          return first.schedaProdotto.perche_andare || ''
        }
      }
      return ''
    },
  },
}
</script>

<style lang="scss">
  .information {
    @extend %section_margin;

    @include media-breakpoint-up(md) {
      padding-top: $grid-gutter-20*3;
    }

    &__desc {
      text-align: center;
      position: relative;
      font-size: $font-size-lg;
      margin-bottom: 0;

      @include media-breakpoint-up(lg) {
        padding: 0 4.5em;
      }
    }
    &__icon {
      position: absolute;
      display: none;

      @include media-breakpoint-up(lg) {
        display: block;
      }

      &:first-child {
        top: 0;
        left: 0;
      }
      &:last-child {
        transform: rotate(180deg);
        bottom: 0;
        right: 0;
      }
    }
  }
</style>
